import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageContent } from '@/lib/seo/pageContent';

const SITE = 'https://trinitydentalarts.com';

export default function GlobalPageSchema() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const meta = pageContent[path];
    if (!meta || path === '/thank-you' || path.startsWith('/admin')) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.globalPageSchema = 'true';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org', '@type': 'WebPage',
      '@id': SITE + path + '#webpage', url: SITE + path,
      name: meta.title, description: meta.description, inLanguage: 'en-US',
      isPartOf: { '@id': SITE + '/#website' },
      about: { '@id': SITE + '/#organization' },
    });
    document.head.appendChild(script);
    return () => script.remove();
  }, [pathname]);
  return null;
}
